import {NgModule} from '@angular/core';
import {ContentBoxComponent} from './content-box.component';
import {SharedModule} from '../../shared/shared.module';


@NgModule({
    imports: [
        SharedModule,
        ContentBoxComponent
    ],
    exports: [
        ContentBoxComponent
    ]
})
export class ContentBoxModule { }
